import {
  apiAddFavorite,
  apiGetFavorites,
  apiRemoveFavorite,
} from "../api/favorites.api";
import { checkoutPosOrder } from "../services/checkout.service";
import { CHECKOUT_RETURN_FLAG } from "./app.constants";
import {
  closeProductSheet,
  productKey,
} from "./app.helpers";

export function createUiHandlers(ctx) {
  const {
    chatId,
    cartItems,
    cartSummary,
    preset,
    checkoutLoading,
    setCheckoutLoading,
    setCartOpen,
    setProductOpen,
    setSheetProduct,
    setCatalogOpen,
    setScreen,
    setPresetModalOpen,
    setAwaitingCheckout,
    setDeliveryOpen,
    onAction,
    onCtaClick,
    favoriteIds,
    setFavoriteIds,
    favoriteItems,
    setFavoriteItems,
    setMiniCatalogOpen,
setMiniCatalogTitle,
setMiniCatalogProducts,
  } = ctx;

  function openCart() {
  if (ctx.catalogOpen) setCatalogOpen(false);

  // 🔥 закриваємо mini catalog
  if (ctx.miniCatalogOpen) {
    setMiniCatalogOpen(false);
  }

  if (ctx.productOpen) {
    closeProductSheet(setProductOpen, setSheetProduct);
  }

  setCartOpen(true);
}

  function handleOpenCatalog() {
    if (ctx.cartOpen) setCartOpen(false);

    if (ctx.productOpen) {
      closeProductSheet(setProductOpen, setSheetProduct);
    }

    setCatalogOpen(true);
  }

  function handleCtaClick(cta) {
  const label = String(cta?.label || "");

  if (cta?.id === "beer_finder_my") {
    ctx.setBeerFinderMode?.("saved");
    ctx.setBeerFinderOpen?.(true);
    return;
  }

  if (cta?.id === "beer_finder") {
    ctx.setBeerFinderMode?.("quiz");
    ctx.setBeerFinderOpen?.(true);
    return;
  }

  if (cta?.id === "cta_menu" || /меню|каталог/i.test(label)) {
    handleOpenCatalog();
    return;
  }

  return onCtaClick(cta);
}

  async function handleAction(action) {
    if (action?.type === "open_catalog") {
      handleOpenCatalog();
      return;
    }

    if (action?.type === "open_product") {
      const p = action.product || null;
      if (p) {
        setSheetProduct(p);
        setProductOpen(true);
      }
      return;
    }

    if (action?.type === "open_mini_catalog") {
  setMiniCatalogTitle(action.title || "Каталог");
  setMiniCatalogProducts(Array.isArray(action.products) ? action.products : []);
  setMiniCatalogOpen(true);
  return;
}

    const result = await onAction(action);

    if (result?.reason === "auth_required") {
      setProductOpen(false);
      setSheetProduct(null);
      setCatalogOpen(false);
      setCartOpen(false);
      setScreen("chat");
    }

    return result;
  }

  async function handleCheckoutToOdoo() {
    if (checkoutLoading) return;

    if (!ctx.isLoggedIn) {
  alert("Увійдіть або зареєструйтесь, щоб оформити замовлення");
  return;
}

    try {
      setCheckoutLoading(true);

      const safeChatId = String(chatId || "").trim();
      if (safeChatId) {
        sessionStorage.setItem("checkout_chat_id", safeChatId);
      }

      sessionStorage.setItem(CHECKOUT_RETURN_FLAG, "1");
      sessionStorage.setItem("checkout_return_pending", "1");

      sessionStorage.setItem(
  "checkout_started_at",
  String(Date.now())
);

      const res = await checkoutPosOrder({ preset, cartItems });

      const url = res?.mono?.pageUrl;
      if (!url) throw new Error("Missing mono.pageUrl from backend");

      setCartOpen(false);
      window.location.href = url;
    } catch (e) {
      console.error(e);
      alert(e?.message || "Checkout failed");
      setCheckoutLoading(false);
      sessionStorage.removeItem(CHECKOUT_RETURN_FLAG);
      sessionStorage.removeItem("checkout_return_pending");
      sessionStorage.removeItem("checkout_chat_id");
    }
  }

  function handleCheckoutClick() {
    if (checkoutLoading) return;
    if ((cartSummary?.itemsCount || 0) <= 0) return;

    setAwaitingCheckout(true);
    setPresetModalOpen(true);
  }

  async function loadFavoritesSafe({ ignoreRef }) {
    if (!ctx.authReady) return;
    if (!ctx.isLoggedIn) {
      setFavoriteIds([]);
      setFavoriteItems([]);
      return;
    }

    try {
      const res = await apiGetFavorites();
      if (ignoreRef.current) return;

      if (res?.unauthenticated) {
        setFavoriteIds([]);
        setFavoriteItems([]);
        return;
      }

      setFavoriteIds(Array.isArray(res?.ids) ? res.ids : []);
      setFavoriteItems(Array.isArray(res?.items) ? res.items : []);
    } catch (e) {
      console.error("favorites load error", e);
    }
  }

  async function handleToggleFavorite(product) {
    const key = productKey(product);
    if (!key) return;

    const exists = favoriteIds.includes(key);

    try {
      if (exists) {
        const res = await apiRemoveFavorite(product);

        if (res?.unauthenticated) {
          alert("Увійдіть в акаунт, щоб користуватись обраним");
          return;
        }

        setFavoriteIds((prev) =>
          prev.filter((id) => String(id) !== String(key))
        );

        setFavoriteItems((prev) =>
          prev.filter((p) => String(productKey(p)) !== String(key))
        );
      } else {
        const res = await apiAddFavorite(product);

        if (res?.unauthenticated) {
          alert("Увійдіть в акаунт, щоб зберігати товари в обране");
          return;
        }

        setFavoriteIds((prev) => {
          const next = prev.filter((id) => String(id) !== String(key));
          return [key, ...next];
        });

        setFavoriteItems((prev) => {
          const next = prev.filter((p) => String(productKey(p)) !== String(key));
          return [product, ...next];
        });
      }
    } catch (e) {
      console.error("favorite toggle error", e);
      alert(e?.message || "Failed to update favorites");
    }
  }

  function handleMessageAction(action) {
    if (!action?.type) return;

    if (action.type === "open_user_menu") {
      window.dispatchEvent(new CustomEvent("chatshop:open-user-menu"));
    }
  }

  function handleOpenProduct(p) {
    if (!p) return;
    setSheetProduct(p);
    setProductOpen(true);
  }

  function handleProductAddToCart(p) {
    const pid = p?.variant_id || p?.product_id || p?.id;
    if (!pid) return;

    return handleAction({
      type: "add_to_cart",
      product_id: pid,
      product: { ...p, id: pid },
      qty: 1,
    });
  }

  function handleCheckoutBack() {
    setScreen("chat");
  }

  function buildCheckoutProps() {
    return {
      cartItems,
      total: cartSummary.total,
      onCheckout: handleCheckoutClick,
      onDecrementItem: (id) =>
        handleAction({ type: "decrement_cart", product_id: id, qty: 1 }),
      onIncrementItem: (it) =>
        handleAction({
          type: "add_to_cart",
          product_id: it.id,
          product: it,
          qty: 1,
        }),
      onRemoveItem: (id) =>
        handleAction({ type: "remove_from_cart", product_id: id }),
      loading: checkoutLoading,
    };
  }

  return {
    openCart,
    handleOpenCatalog,
    handleCtaClick,
    handleAction,
    handleCheckoutToOdoo,
    handleCheckoutClick,
    loadFavoritesSafe,
    handleToggleFavorite,
    handleMessageAction,
    handleOpenProduct,
    handleProductAddToCart,
    handleCheckoutBack,
    buildCheckoutProps,
  };
}